// ISDP CUSTOM — i18n "home" namespace (HomePage). See ./common.ts for the convention.
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const homeMessages = createTranslationRef({
  id: 'devhub.home',
  messages: {
    hero: {
      title: 'What are you looking for?',
      sub: 'Explore guidelines, documentation and technical components to design, develop and distribute digital solutions at Dräger.',
      gettingStarted: 'Getting Started',
      selfService: 'Self Service',
    },
    cards: {
      catalog: {
        title: 'Catalog',
        desc: 'Browse all components, APIs, tools and services across Dräger — find what exists before you build.',
        cta: 'Open Catalog',
      },
      guides: {
        title: 'Getting Started',
        desc: 'How to design, develop and distribute digital solutions at Dräger.',
        cta: 'Get Started',
      },
      docs: {
        title: 'Documentation',
        desc: 'Product and platform documentation from all Dräger teams.',
        cta: 'Browse Docs',
      },
      selfService: {
        title: 'Self Service',
        desc: 'Spin up new projects, manage existing ones, and order the modules your team needs.',
        cta: 'Open Self Service',
      },
      resources: {
        title: 'Resources',
        desc: 'Self-service actions, the MCP catalog, system status and support — the platform toolbox.',
        cta: 'Open Resources',
      },
      genai: {
        pill: 'Featured',
        title: 'GenAI at Dräger',
        desc: 'GAIA, MCP servers, and guidelines for AI-assisted development.',
        cta: 'Learn more',
      },
    },
    personalized: {
      aria: 'Your recent activity',
      recentTitle: 'Jump back in',
      whatsNew: '{{n}} updates since your last visit',
    },
    about: {
      heading: 'About us',
      catalog: {
        title: 'Software Catalog',
        desc: "Browse all services, libraries, and systems across the organization. Find owners, dependencies, and technical metadata — everything you need to understand what's running and who's responsible.",
      },
      docs: {
        title: 'Documentation',
        desc: 'Access technical documentation powered by TechDocs. Architecture decisions, onboarding guides, and runbooks — all version-controlled alongside your code and searchable in one place.',
      },
      landscape: {
        title: 'Technology Landscape',
        desc: 'Explore the approved technology stack at a glance. See which languages, frameworks, tools, and platforms are standardized — helping teams make consistent, informed technology choices.',
      },
      scaffolder: {
        title: 'Scaffolder',
        desc: 'Spin up new projects from golden-path templates. Pre-configured repositories with CI/CD pipelines, linting, and best practices — production-ready in minutes, not days.',
      },
      api: {
        title: 'API Registry',
        desc: 'Discover and explore internal APIs. View OpenAPI specs, gRPC definitions, and AsyncAPI contracts with interactive documentation — making integration between teams effortless.',
      },
      search: {
        title: 'Unified Search',
        desc: 'Search across everything — entities, documentation, APIs, and templates. One query to find anything in the developer ecosystem, no matter where it lives.',
      },
    },
  },
  translations: {
    de: () => import('./de/home'),
  },
});
